// extracted by mini-css-extract-plugin
export default {"wrapper":"yk","center":"zk"};